export default __webpack_public_path__ + "83dfa2446e356e55ae79072a1c696c92.png";